module.exports = __webpack_public_path__ + "img/services_setting.6314b6ea.svg";